<script>
import {corrigirEstadas} from '../../../../../domain/grv/services'
import PopupViewerAlert from '../../../../_default/components/popup-viewer/PopupViewerAlert'

export default {
  name: 'BtnCorrigirDiarias',
  components: {PopupViewerAlert},
  data () {
    return {
      show: false,
      quantidadeDiarias: null
    }
  },
  props: {
    quantidadeDiariasAtual: {
      type: [String, Number],
      required: true
    },
    grvId: {
      type: [String, Number],
      required: true
    }
  },
  watch: {
    show (v) {
      if (!v) {
        this.quantidadeDiarias = null
      } else {
        setTimeout(() => {
          const {inputCorrigeDiarias} = this.$refs
          inputCorrigeDiarias && inputCorrigeDiarias.focus()
        }, 360)
      }
    }
  },
  methods: {
    corrigirEstadas () {
      let answer = this.quantidadeDiarias
      if (answer === null || !String(answer).trim()) return

      if (isNaN(+answer)) {
        alert('Valor inválido!!')
        return
      }
      answer = parseInt(answer)

      const confirmado = confirm(`ATENÇÃO: Confirmar alteração para ${answer} diárias?`)
      if (!confirmado) return

      this.$loaderOverlay.open().message('Alterando diárias da GRV...')
      corrigirEstadas(this.grvId, answer, this.quantidadeDiariasAtual)
        .then(response => {
          this.show = false
          this.$emit('corrigido')
        })
        .catch(error => {
          alert('Houve um erro ao alterar as diárias da GRV')
          console.log(error.data)
          this.$loaderOverlay.hide()
        })
    }
  }
}
</script>

<template>
  <div>
    <button class="btn btn-default font-bold" @click="show = true">Corrigir diárias</button>
    <popup-viewer-alert v-if="show" title="Corrigir diárias">
      <div class="btn-corrigir-datas form-group">
        <input
          ref="inputCorrigeDiarias"
          v-model="quantidadeDiarias"
          type="number"
          class="form-control"
          autofocus
          placeholder="Quantidade correta de diárias"
          min="0"
        />
      </div>
      <div style="display: flex; justify-content: end; align-items: center">
        <button class="btn btn-sm btn-default m-l" @click="show = false">Cancelar</button>
        <button class="btn btn-sm btn-info m-l" @click="corrigirEstadas" :disabled="!quantidadeDiarias">Confirmar</button>
      </div>
    </popup-viewer-alert>
  </div>
</template>

<style scoped>
.btn-corrigir-datas {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// BtnCorrigirDiarias.vue?b46a3208